/* eslint-disable react/style-prop-object */
import React from 'react';

const CommentIcon = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1950_31171" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
      <path d="M61.3333 0H18.6667C8.35735 0 0 8.35735 0 18.6667V61.3333C0 71.6427 8.35735 80 18.6667 80H61.3333C71.6427 80 80 71.6427 80 61.3333V18.6667C80 8.35735 71.6427 0 61.3333 0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_1950_31171)">
      <path d="M61.3333 0H18.6667C8.35735 0 0 8.35735 0 18.6667V61.3333C0 71.6427 8.35735 80 18.6667 80H61.3333C71.6427 80 80 71.6427 80 61.3333V18.6667C80 8.35735 71.6427 0 61.3333 0Z" fill="url(#paint0_linear_1950_31171)" />
      <path fillRule="evenodd" clipRule="evenodd" d="M31.92 61.078C34.4867 61.678 37.1973 62 39.9993 62C56.1993 62 69.3327 51.2547 69.3327 38C69.3327 24.7453 56.1993 14 39.9993 14C23.7993 14 10.666 24.7453 10.666 38C10.666 46.6507 16.2593 54.232 24.6493 58.4553C24.1893 61.7267 22.8607 64.13 20.666 65.6667C25.0527 65.6667 28.804 64.1373 31.92 61.078Z" fill="white" />
      <path d="M47.1348 36.8889H47.1508" stroke="#5941A9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M40.0078 36.8889H40.0238" stroke="#5941A9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M32.8809 36.8889H32.8969" stroke="#5941A9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_1950_31171" x1="40" y1="0" x2="40" y2="80" gradientUnits="userSpaceOnUse">
        <stop stopColor="#5941A9" />
        <stop offset="1" stopColor="#DFE0EB" />
      </linearGradient>
    </defs>
  </svg>

);
export default CommentIcon;
